module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("OUT OF THE PIT")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Jocelyn")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("He lifted me out of the slimy pit, out of the mud and mire; he set my feet on a rock and gave me a firm place to stand.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("PSALM 40:2")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("E")])]), _vm._v("llen Stumbo’s hands shook as she hung up the phone. The liver condition detected in her baby, the doctor had called to say, could be fatal. "), _c('i', [_vm._v("“Oh dear Lord. I asked you to take my baby away, and now you are letting me have my way. My baby is going to die.”")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn4",
      "id": "rfn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Guilt and fear knocked Ellen to the floor and unleashed a torrent of sobs. “I faced the dark hole I had been living in since Nichole’s birth,” she wrote on her blog. “It was deep, murky, and tight. It had become a prison. Life happened around me, yet I was stuck. My tears had been so abundant I would soon be covered in my own grief. And it was my despair over what I saw as unfair that would cause me to drown—not my baby, and not her diagnosis. The unending tears blinded me.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn5",
      "id": "rfn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Who among us has not spent time in a similar “hole” of our own? In Genesis we read the story of Joseph being thrown into the pit by his brothers. “The pit was empty; there was no water in it” (Gen. 37:24 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NKJV")]), _vm._v("). Despair is also empty, dark, isolating, and void of nourishment. "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("Job suffered so greatly that his wife suggested he “curse God and die!” (Job 2:9).")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Though the prophet Elijah fled to a mountaintop after his exhausting fight with the prophets of Baal, he found himself in an emotional and spiritual pit. “‘I have had enough, L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(",’ he said. ‘Take my life’” (1 Kings 19:4). But that wasn’t God’s plan. Twice he sent an angel to bring food and drink to Elijah, saying, “Get up and eat, for the journey is too much for you” (v. 7).")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('i', [_vm._v("The journey is too much for you.")]), _vm._v(" The Lord knows this. He did not ridicule or minimize Elijah’s desperation, and he doesn’t do that to us, either. May we cry to God for help, as David did: “Do not let the flood-waters engulf me or the depths swallow me up or the pit close its mouth over me” (Ps. 69:15).")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("For God is mighty to save (Ps. 40:2). Though he allows us to experience the pit, and we must work through our grief, he does not desire that we dwell there permanently.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("That day Ellen learned Nichole could die, she searched her heart. “Could I live knowing I held back from loving my baby because she was not what I had expected, not what I wanted?” She pulled herself to her knees, stretched out her arms to God and cried, “‘I choose love, Lord! From this day on, with everything that is within me, I choose love!’ And God pulled me out of the hole, and held me in his arms. Because he had chosen love for me too.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn6",
      "id": "rfn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("That was several years ago. While Ellen remembers that scare as the moment God pulled her up out of her pit, her life has not been grief-free ever since. She loves Nichole fiercely. Still, grief rolls in and out like an irregular tide, with new medical complications, difficult IEP meetings, missed milestones, and even memories. In her memoir "), _c('i', [_vm._v("Sun Shine Down")]), _vm._v(", Gillian Marchenko shares that when her daughter with Down syndrome was twenty-one months old, “Grief packed up his bags and told me he was going hitchhiking across the country, though he promised to send postcards.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn7",
      "id": "rfn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("No matter how many times we slip into grief, God does not scold us for being there. Gently, lovingly, he offers his hand. His message to Elijah he says to us as well: "), _c('i', [_vm._v("I know the journey is too much for you. Let me help you up and nourish you with living water.")])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Lord, help me learn how to grieve my losses in healthy ways. Thank you that I don’t need to hide my grief from you. Help me up out of the pit, and give me a firm place to stand. In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("When was the last time you felt stuck in a pit?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What most helped you to climb out?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Next time you slip into a pit, how do you hope to handle it?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83e08dfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter03.vue
// module id = 90
// module chunks = 0